export default __webpack_public_path__ + "956501269cd71d5cf13f558f48d32dfb.svg";